/**
 * The plan an Upgrade button offers. Pure.
 */

/** The plan one up from this one, for an Upgrade button; none above Max. */
export function nextTier(tier: "free" | "pro" | "max" | undefined): "pro" | "max" | null {
    if (tier === "free") return "pro";
    if (tier === "pro") return "max";
    return null;
}
